/**
 * 아이콘 획 굵기 규칙
 * @description **화면에서 보이는 굵기**를 크기가 정한다 — 24 아래는 1.5, 24 부터는 2.
 *   작은 글리프에 2 를 그대로 두면 획이 서로 붙어 뭉개진다. 앱 `iconStroke.ts` 와 같은 규칙.
 *
 *   lucide-react 는 `absoluteStrokeWidth` 를 켜면 넘긴 값이 곧 보이는 굵기가 된다.
 * @example
 * <Bell size={16} strokeWidth={iconStrokeWidth(16)} absoluteStrokeWidth />
 */

/** 크기를 안 받은 아이콘이 서는 자리 — `size.icon.md` */
const DEFAULT_SIZE = 24;
/** 이 크기부터 굵은 획을 쓴다 — 시안의 24 그리드 */
const THICK_FROM = 24;
/** `border.md` · `border.lg` — 토큰 파일이 CSS 변수라 JS 에서는 값을 옮겨 적는다. */
const STROKE_THIN = 1.5;
const STROKE_THICK = 2;

export const iconStrokeWidth = (size: number = DEFAULT_SIZE): number =>
  size < THICK_FROM ? STROKE_THIN : STROKE_THICK;
